import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { Project } from "vmd-types";

type OeOption = { id: string; label: string };

type OeMultiSelectProps = {
  label: string;
  placeholder: string;
  projects: Project[];
  value: string[];
  onChange: (projectIds: string[]) => void;
};

export const OeMultiSelect = ({
  label,
  placeholder,
  projects,
  value,
  onChange,
}: OeMultiSelectProps) => {
  const [search, setSearch] = useState("");
  const options = useMemo<OeOption[]>(
    () =>
      projects.map((project) => ({
        id: String(project.id),
        label: project.customId
          ? `${project.customId} - ${project.name}`
          : (project.name ?? ""),
      })),
    [projects]
  );

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      size="small"
      limitTags={5}
      options={options}
      value={options.filter((option) => value.includes(option.id))}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      onChange={(_, selected) => onChange(selected.map((option) => option.id))}
      // MUI clears the search after each pick; keep it so several matches can be ticked in a row.
      inputValue={search}
      onInputChange={(_, text, reason) => {
        if (reason === "input" || reason === "clear" || reason === "blur") {
          setSearch(text);
        }
      }}
      renderOption={({ key, ...props }, option, { selected }) => (
        <li key={key} {...props}>
          <Checkbox size="small" checked={selected} sx={{ mr: 1, p: 0 }} />
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
    />
  );
};
